// assets/cart-progress.js
// Cart weight, roll milestones, and optional live rates (multi-instance)
// Works with Dawn cart drawer + PDP placement

(function () {
  // Initialize every .cart-progress found on the page (supports duplicates)
  function initAll() {
    const roots = Array.from(document.querySelectorAll('.cart-progress'))
      .filter((el) => !el.__cp_inited);
    roots.forEach(initWidget);
  }

  // Observe DOM for newly added cart drawers, PDP sections, etc.
  const mo = new MutationObserver(initAll);
  mo.observe(document.documentElement, { childList: true, subtree: true });

  // Also run on first load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }


  // ---- Widget init (scoped per root) ----
  function initWidget(root) {
    root.__cp_inited = true;

    // --- CONFIG from snippet data-attrs ---
    const SENDLE_MAX = parseFloat(root.dataset.sendleMax || '25'); // kg
    const AUSPOST_MAX = parseFloat(root.dataset.auspostMax || '22'); // kg
    const ROLL_MILESTONES = (root.dataset.rollMilestones || '5,10,15')
      .split(',')
      .map((n) => parseInt(n.trim(), 10))
      .filter((n) => !isNaN(n) && n > 0);

    // Optional flat estimates (if set in theme settings)
    const EST_SENDLE_RATE = parseFloat(root.dataset.estSendleRate || '0'); // AUD
    const EST_AUSPOST_RATE = parseFloat(root.dataset.estAuspostRate || '0'); // AUD

    // Roll detection heuristic
    const ROLL_MIN_KG = 0.8;
    const ROLL_MAX_KG = 1.6;
    const ROLL_PRODUCT_TYPE_KEYWORD = 'Filament'; // set your spools' product_type accordingly

    // --- Scoped DOM refs (IDs are duplicated per snippet, so always scope via root) ---
    const $w = root.querySelector('#cp-weight');
    const $i = root.querySelector('#cp-items');
    const $r = root.querySelector('#cp-rolls');

    const $sendle = root.querySelector('#cp-sendle');
    const $auspost = root.querySelector('#cp-auspost');
    const $sendleH = root.querySelector('#cp-sendle-help');
    const $auspostH = root.querySelector('#cp-auspost-help');

    const $rollsBar = root.querySelector('#cp-rolls-bar');
    const $rollsHelp = root.querySelector('#cp-rolls-help');
    const $rollsTicks = root.querySelector('#cp-rolls-ticks'); // <-- query AFTER root exists
    const $rollsLabel = root.querySelector('#cp-rolls-label');
    const $ausChip = root.querySelector('#cp-auspost-chip');
    const $senChip = root.querySelector('#cp-sendle-chip');


    const $shipRow = root.querySelector('#cp-shipping-row');
    const $shipCost = root.querySelector('#cp-ship-cost');
    const $shipPer = root.querySelector('#cp-ship-per');

    // Address + live rates (optional)
    const $form = root.querySelector('#cp-address');
    const $ratesWrap = root.querySelector('#cp-rates');
    const $ratesList = root.querySelector('#cp-rates-list');
    const $ratesNote = root.querySelector('#cp-rates-note');
    const $ratesEmpty = root.querySelector('#cp-rates-empty');
    const $ratesErr = root.querySelector('#cp-rates-error');
    const $ratesPerRoll = root.querySelector('#cp-rates-per-roll');

    // --- State ---
    let lastTotals = { totalKg: 0, itemCount: 0, rolls: 0 };
    let lastAddress = null;

    // --- Helpers ---
    const kg = (n) => Math.round(n * 10) / 10; // 0.1 kg precision
    const clamp01 = (v) => Math.max(0, Math.min(1, v));
    const fmtMoney = (n) =>
      new Intl.NumberFormat('en-AU', { style: 'currency', currency: 'AUD' }).format(n);

    function isRoll(line) {
      const unitKg = (line.grams || 0) / 1000;
      const unitLooksLikeRoll = unitKg >= ROLL_MIN_KG && unitKg <= ROLL_MAX_KG;
      const typeLooksLikeRoll = (line.product_type || '')
        .toLowerCase()
        .includes(ROLL_PRODUCT_TYPE_KEYWORD.toLowerCase());
      return unitLooksLikeRoll || typeLooksLikeRoll;
    }

    function chooseCarrier(totalKg) {
      const canSendle = totalKg <= SENDLE_MAX;
      const canAus = totalKg <= AUSPOST_MAX;
      if (!canSendle && !canAus)
        return { name: 'Split shipment', maxKg: Math.max(SENDLE_MAX, AUSPOST_MAX) };
      if (canSendle && canAus) {
        if (EST_SENDLE_RATE > 0 && EST_AUSPOST_RATE > 0) {
          return EST_SENDLE_RATE <= EST_AUSPOST_RATE
            ? { name: 'Sendle', maxKg: SENDLE_MAX }
            : { name: 'Aus Post', maxKg: AUSPOST_MAX };
        }
        return { name: 'Sendle', maxKg: SENDLE_MAX };
      }
      if (canSendle) return { name: 'Sendle', maxKg: SENDLE_MAX };
      if (canAus) return { name: 'Aus Post', maxKg: AUSPOST_MAX };
    }

    // ---- Dynamic roll ticks ----
    function renderRollTicks() {
      if (!$rollsTicks) return;
      $rollsTicks.innerHTML = '';
      const max = Math.max(...(ROLL_MILESTONES.length ? ROLL_MILESTONES : [15]));
      ROLL_MILESTONES.forEach((m) => {
        const tick = document.createElement('span');
        tick.className = 'cp-tick';
        tick.textContent = String(m);
        tick.style.left = (m / max * 100) + '%';
        $rollsTicks.appendChild(tick);
      });
    }
    renderRollTicks();


    // Shared progress painter used by all bars
function setBar($fill, pct) {
  if (!$fill) return;

  let p = Number(pct);
  if (!Number.isFinite(p) || p < 0) p = 0;
  const clamped = Math.min(1, p);
  const percent = clamped * 100;

  // Inner fill
  $fill.style.removeProperty('width');
  $fill.style.setProperty('width', percent + '%', 'important');
  $fill.style.transform = `scaleX(${clamped})`;
  $fill.style.transformOrigin = 'left center';

  // Paint parent bar as fallback
  const bar = $fill.parentElement;
  if (bar) {
    bar.style.backgroundImage = `linear-gradient(to right, #16a34a ${percent}%, rgba(0,0,0,.06) 0)`;
    bar.setAttribute('role', 'progressbar');
    bar.setAttribute('aria-valuemin', '0');
    bar.setAttribute('aria-valuemax', '100');
    bar.setAttribute('aria-valuenow', String(Math.round(percent)));
  }

  // State classes
  $fill.classList.toggle('is-near',  p >= 0.85 && p <= 1.0);
  $fill.classList.toggle('is-over',  p > 1.0);
}


    function setMultiBox($fill, $help, $chip, totalKg, BOX_MAX, label) {
  const boxes = Math.floor(totalKg / BOX_MAX);                   // full boxes
  const remainder = Math.max(0, totalKg - boxes * BOX_MAX);      // kg in current box
  const pct = remainder / BOX_MAX;                                // progress of the current box [0..1]
  setBar($fill, pct);

  // Helper text under the bar
  if ($help) {
    if (boxes === 0) {
      const left = kg(BOX_MAX - remainder);
      $help.textContent = `${left.toFixed(1)} kg left to fill ${label} (${BOX_MAX}kg max per box)`;
    } else {
      const s = boxes === 1 ? '' : 'es';
      const prefix = `${label} (${BOX_MAX}kg max per box) – ${boxes} box${s} full`;
      if (remainder > 0) {
        const left = kg(BOX_MAX - remainder);
        $help.textContent = `${prefix} • ${left.toFixed(1)} kg left to fill next box`;
      } else {
        // Exactly on a box boundary -> show “n boxes full” and an empty (reset) bar
        $help.textContent = prefix;
      }
    }
  }

  // Small chip in the headline row
  if ($chip) {
    if (boxes > 0) {
      const s = boxes === 1 ? '' : 'es';
      $chip.innerHTML = `<span class="cp-dot"></span><strong>${label}:</strong> ${boxes}× box${s} full`;
      $chip.style.display = '';
    } else {
      $chip.textContent = '';
      $chip.style.display = 'none';
    }
  }
}


    function updateBars(totalKg, items, rolls) {
      // text
      if ($w) $w.textContent = kg(totalKg).toFixed(1);
      if ($i) $i.textContent = items;
      if ($r) $r.textContent = rolls;
      
// --- Sendle (25 kg), wraps per-box and shows count ---
setMultiBox($sendle, $sendleH, $senChip, totalKg, SENDLE_MAX, 'Sendle');

// --- Aus Post (22 kg), wraps per-box and shows count ---
setMultiBox($auspost, $auspostH, $ausChip, totalKg, AUSPOST_MAX, 'Aus Post');




// Rolls milestones (use highest milestone as “100%”)
const maxMilestone = Math.max(...(ROLL_MILESTONES.length ? ROLL_MILESTONES : [15]));
const rPct = rolls / maxMilestone;
setBar($rollsBar, rPct);

const nextM = ROLL_MILESTONES.find((m) => rolls < m);
if ($rollsHelp) {
  $rollsHelp.textContent = nextM
    ? `Add ${nextM - rolls} more roll${nextM - rolls === 1 ? '' : 's'} to unlock better shipping value`
    : `Nice! You’ve reached our top roll milestone.`;
}

// --- Roll milestone discount math ---
if ($rollsLabel) {
  const discount = Math.floor(rolls / 5) * 5;       // e.g. 0,5,10,15...
  $rollsLabel.textContent = `Roll milestones (Current discount $${discount})`;
}
} // <-- closes updateBars

    function updateShippingEstimate(totalKg, rolls) {
      const hasEstimates = EST_SENDLE_RATE > 0 || EST_AUSPOST_RATE > 0;
      if (!hasEstimates) {
        if ($shipRow) $shipRow.style.display = 'none';
        return;
      }
      const carrier = chooseCarrier(totalKg);
      if (!carrier) {
        if ($shipRow) $shipRow.style.display = 'none';
        return;
      }

      let est = 0;
      if (carrier.name === 'Sendle') est = EST_SENDLE_RATE || EST_AUSPOST_RATE;
      else if (carrier.name === 'Aus Post') est = EST_AUSPOST_RATE || EST_SENDLE_RATE;
      else est = Math.max(EST_SENDLE_RATE, EST_AUSPOST_RATE);

      if (!est) {
        if ($shipRow) $shipRow.style.display = 'none';
        return;
      }

      if ($shipRow) $shipRow.style.display = '';
      if ($shipCost) $shipCost.textContent = `${fmtMoney(est)} via ${carrier.name}`;
      if ($shipPer) $shipPer.textContent = rolls > 0 ? fmtMoney(est / rolls) : '—';
    }

    async function refreshCart() {
      const res = await fetch('/cart.js', { credentials: 'same-origin' });
      if (!res.ok) throw new Error('Cart fetch failed');
      const cart = await res.json();

      let totalKg = 0;
      let rolls = 0;

      (cart.items || []).forEach((line) => {
        const unitKg = (line.grams || 0) / 1000;
        totalKg += unitKg * (line.quantity || 0);
        if (isRoll(line)) rolls += (line.quantity || 0);
      });

      lastTotals = { totalKg, itemCount: cart.item_count || 0, rolls };
      updateBars(totalKg, cart.item_count || 0, rolls);
      updateShippingEstimate(totalKg, rolls);
    }

    // --- Live rates (optional pre-checkout estimate using Shopify endpoint) ---
    async function fetchRates(addr) {
      // Store in cart attributes (optional; helps survive refresh within session)
      try {
        await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({
            attributes: {
              _ship_country: addr.country,
              _ship_province: addr.province,
              _ship_city: addr.city,
              _ship_zip: addr.zip,
              _ship_address1: addr.address1
            }
          })
        });
      } catch (_) {}

      const qs = new URLSearchParams({
        'shipping_address[country]': addr.country || '',
        'shipping_address[province]': addr.province || '',
        'shipping_address[city]': addr.city || '',
        'shipping_address[zip]': addr.zip || '',
        'shipping_address[address1]': addr.address1 || ''
      });

      const res = await fetch(`/cart/shipping_rates.json?${qs.toString()}`, {
        credentials: 'same-origin'
      });
      if (!res.ok) throw new Error('rates failed');
      return res.json(); // { shipping_rates: [{ name, price, ... }] }
    }

function renderRates(rates, rolls) {
  if ($ratesErr) $ratesErr.hidden = true;
  if ($ratesEmpty) $ratesEmpty.hidden = true;
  if ($ratesWrap) $ratesWrap.hidden = false;
  if ($ratesList) $ratesList.innerHTML = '';

  if (!rates || !rates.shipping_rates || rates.shipping_rates.length === 0) {
    if ($ratesWrap) $ratesWrap.hidden = true;
    if ($ratesEmpty) $ratesEmpty.hidden = false;
    return;
  }

  // price comes back as a string like "43.00" (AUD dollars)
  const list = rates.shipping_rates
    .slice()
    .map(r => ({ ...r, _price: parseFloat(r.price || '0') || 0 }))
    .sort((a, b) => a._price - b._price);

  list.forEach(r => {
    const li = document.createElement('li');
    const name = document.createElement('div');
    name.className = 'name';
    name.textContent = r.name || r.source || 'Shipping';

    const price = document.createElement('div');
    price.className = 'price';
    price.textContent = fmtMoney(r._price);  // <- no /100

    li.appendChild(name);
    li.appendChild(price);
    if ($ratesList) $ratesList.appendChild(li);
  });

  const cheapest = list[0];
  if ($ratesPerRoll) {
    const per = cheapest && rolls > 0 ? (cheapest._price / rolls) : null; // <- no /100
    $ratesPerRoll.textContent = per ? `From ${fmtMoney(per)} per roll at your address.` : '';
  }
  if ($ratesNote) $ratesNote.hidden = false;
}


    async function refreshAll() {
      try {
        await refreshCart();
        if (lastAddress) {
          const data = await fetchRates(lastAddress);
          renderRates(data, lastTotals.rolls);
        }
      } catch (_) {
        // keep quiet; widget still shows weight/milestones
      }
    }

    // Address form submit (if present in this instance)
    if ($form) {
      $form.addEventListener('submit', async (e) => {
        e.preventDefault();
        const fd = new FormData($form);
        const addr = {
          country: (fd.get('country') || '').toString().trim(),
          province: (fd.get('province') || '').toString().trim(),
          city: (fd.get('city') || '').toString().trim(),
          zip: (fd.get('zip') || '').toString().trim(),
          address1: (fd.get('address1') || '').toString().trim()
        };
        if (!addr.country || !addr.province || !addr.city || !addr.zip || !addr.address1) return;

        if ($ratesErr) $ratesErr.hidden = true;
        if ($ratesEmpty) $ratesEmpty.hidden = true;
        if ($ratesWrap) $ratesWrap.hidden = false;
        if ($ratesList) $ratesList.innerHTML = '<li>Fetching rates…</li>';
        if ($ratesPerRoll) $ratesPerRoll.textContent = '';

        try {
          lastAddress = addr;
          const data = await fetchRates(addr);
          renderRates(data, lastTotals.rolls);
        } catch (err) {
          if ($ratesWrap) $ratesWrap.hidden = true;
          if ($ratesEmpty) $ratesEmpty.hidden = true;
          if ($ratesErr) $ratesErr.hidden = false;
        }
      });
    }

// ----- Sticky address + account prefill -----
(function setupStickyAndPrefill(){
  if (!$form) return;

  const KEY = 'cp-address-v1'; // localStorage key (bump the suffix if you ever change the schema)

  const fields = {
    country:  $form.querySelector('input[name="country"]'),
    province: $form.querySelector('input[name="province"]'),
    city:     $form.querySelector('input[name="city"]'),
    zip:      $form.querySelector('input[name="zip"]'),
    address1: $form.querySelector('input[name="address1"]'),
  };

  // Apply an address object to the form
  function apply(addr = {}) {
    if (fields.country)  fields.country.value  = addr.country  || 'Australia';
    if (fields.province) fields.province.value = addr.province || '';
    if (fields.city)     fields.city.value     = addr.city     || '';
    if (fields.zip)      fields.zip.value      = addr.zip      || '';
    if (fields.address1) fields.address1.value = addr.address1 || '';
  }

  // Read current form values
  function read() {
    return {
      country:  fields.country?.value?.trim()  || 'Australia',
      province: fields.province?.value?.trim() || '',
      city:     fields.city?.value?.trim()     || '',
      zip:      fields.zip?.value?.trim()      || '',
      address1: fields.address1?.value?.trim() || '',
    };
  }

  // Save to localStorage (debounced)
  let saveTO;
  function scheduleSave() {
    clearTimeout(saveTO);
    saveTO = setTimeout(() => {
      try { localStorage.setItem(KEY, JSON.stringify(read())); } catch(_) {}
      // mirror into cart attributes so it sticks across some sessions
      try {
        const a = read();
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({
            attributes: {
              _ship_country: a.country,
              _ship_province: a.province,
              _ship_city: a.city,
              _ship_zip: a.zip,
              _ship_address1: a.address1
            }
          })
        }).catch(()=>{});
      } catch(_) {}
    }, 250);
  }

  // 1) Try to restore from localStorage first (user’s last typed address)
  let restored = false;
  try {
    const raw = localStorage.getItem(KEY);
    if (raw) {
      const parsed = JSON.parse(raw);
      if (parsed && (parsed.address1 || parsed.city || parsed.zip)) {
        apply(parsed);
        restored = true;
      }
    }
  } catch(_) {}

  // 2) If nothing restored, and customer is logged in, prefill from their default address
  if (!restored) {
    const d = $form.dataset || {};
    if (d.custAddress1 || d.custCity || d.custProvince || d.custZip) {
      apply({
        country:  'Australia',
        address1: d.custAddress1 || '',
        city:     d.custCity || '',
        province: d.custProvince || '',
        zip:      d.custZip || ''
      });
    }
  }

  // 3) Watch for changes and keep sticky copy up to date
  Object.values(fields).forEach(($f) => {
    if (!$f) return;
    $f.addEventListener('input', scheduleSave);
    $f.addEventListener('change', scheduleSave);
    $f.addEventListener('blur', scheduleSave);
  });

  // 4) Expose the lastAddress to the widget so live-rate refresh can reuse it
  const a = read();
  if (a.address1 || a.city || a.zip) {
    lastAddress = a; // this is already declared in your file's state block
  }
})();



    // Listen to common cart update events (Dawn often dispatches these)
    document.addEventListener('cart:refresh', refreshAll);
    document.addEventListener('ajaxProduct:added', refreshAll);
    document.addEventListener('cart:updated', refreshAll);

    // Initial + fallback polling
    refreshAll();
    root.__cp_interval = setInterval(refreshAll, 5000);

    // Clean up if the node is removed
    const ro = new MutationObserver(() => {
      if (!document.body.contains(root)) {
        clearInterval(root.__cp_interval);
        ro.disconnect();
      }
    });
    ro.observe(document.body, { childList: true, subtree: true });
  }
})();
